import { useSyncExternalStore } from 'react';

export type LlmProvider = 'gemini' | 'claude' | 'openai' | 'xai';

const STORAGE_KEY = 'llm_provider';
const EVENT_NAME = 'llm-provider-change';
const VALID: readonly LlmProvider[] = ['gemini', 'claude', 'openai', 'xai'];

function read(): LlmProvider {
  const raw = (typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || '';
  return (VALID as readonly string[]).includes(raw) ? (raw as LlmProvider) : 'gemini';
}

function subscribe(onChange: () => void): () => void {
  const handler = () => onChange();
  window.addEventListener(EVENT_NAME, handler);
  // Cross-tab: storage event fires for writes from other tabs/windows
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(EVENT_NAME, handler);
    window.removeEventListener('storage', handler);
  };
}

export function setLlmProvider(p: LlmProvider): void {
  localStorage.setItem(STORAGE_KEY, p);
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function useLlmProvider(): LlmProvider {
  return useSyncExternalStore(subscribe, read, read);
}
